module.exports = __webpack_public_path__ + "img/DFM_white.2cae910b.svg";